module.exports = __webpack_public_path__ + "img/AboutImage.657e6e4f.png";